import Plyr from 'plyr';
import gsap from 'gsap';

const repositionVideo = videoNode => {
    const width = (videoNode.offsetParent.clientWidth - videoNode.clientWidth) / 2;
    videoNode ? (videoNode.style.transform = `translateX(${Math.min(0, width)}px)`) : null;
};

const videoWidthResizeObserver = new ResizeObserver(entries => {
    if (window.innerWidth < 1024) return;
    for (const entry of entries) repositionVideo(entry.target.querySelector('.plyr__video-embed'));
});

export const initFullVideo = () => {
    document.querySelectorAll('.c-full-video').forEach(fullVideo => {
        const playButton = fullVideo.querySelector('.play-button');
        const thumbnail = fullVideo.querySelector('.thumbnail');
        const video = fullVideo.querySelector('.video');

        if (!playButton || !thumbnail || !video || fullVideo.classList.contains('backend')) return;

        let player;

        const isMobile = window.matchMedia('(max-width: 1023px)');

        isMobile.addEventListener('change', x => {
            if (x.matches && player) {
                thumbnail.style.setProperty('opacity', '');
                thumbnail.style.setProperty('visibility', '');
                thumbnail.style.setProperty('display', '');

                !player.playing && !player.fullscreen.active ? player.stop() : player.fullscreen.enter();
            }
        });

        playButton.addEventListener('click', () => {
            // Hide the thumbnail on desktop.
            if (window.innerWidth > 1023) gsap.to(thumbnail, { duration: 1, autoAlpha: 0, display: 'none' });

            if (!player) {
                // Initialize the video player.
                player = new Plyr(video, {
                    autoplay: true,
                    loop: { active: true },
                    vimeo: { title: false },
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                });

                player.on('ready', () => videoWidthResizeObserver.observe(fullVideo.querySelector('.plyr')));

                player.on('playing', () => {
                    if (window.innerWidth < 1024 && player.fullscreen.active === false) player.fullscreen.enter();
                });

                player.on('enterfullscreen', () => fullVideo.classList.add('fullscreen'));

                player.on('exitfullscreen', () => {
                    fullVideo.classList.remove('fullscreen');
                    player.stop();
                });

                new IntersectionObserver(
                    e => {
                        if (player.playing && !e.isIntersecting) player.pause();
                    },
                    { rootMargin: '24px' }
                ).observe(fullVideo);
            } else {
                player.play();
            }
        });
    });
};
